import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getUser } from '~src/user';
import { RetryLink } from '@apollo/client/link/retry';

let graphQlClient;

const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 5,
  },
});

const getGraphQLClient = async () => {
  if (graphQlClient) {
    return graphQlClient;
  }

  const { userToken } = await getUser();

  const httpLink = createHttpLink({
    uri: process.env.GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        'x-parse-application-id': process.env.PARSE_APPLICATION_ID,
        'x-parse-session-token': userToken,
      },
    };
  });

  graphQlClient = new ApolloClient({
    link: from([retryLink, authLink, httpLink]), // Retry link must be placed before http link
    cache: new InMemoryCache({ resultCaching: false }),
  });

  return graphQlClient;
};

export default getGraphQLClient;
